// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetDynamicFormPayloadRequestModel from '../../model/get-dynamic-form-payload-request-model';
import DynamicFormPayloadModel from '../../model/dynamic-form-payload-model';

export default (service: Servicelayer) => ({
  /**  */
  async getDynamicFormPayload(request: GetDynamicFormPayloadRequestModel, config?: RequestConfig) {
    const requestDTO = GetDynamicFormPayloadRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-dynamic-form-payload'] ?? 'core/KfmvDynamicForm/Payload';
    const response = await service.get<any>(endpointPath, {
      query: {
        appSystemKey: requestDTO.appSystemKey,
        formDefinitionId: requestDTO.formDefinitionId,
        contactId: requestDTO.contactId,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(DynamicFormPayloadModel.toModel(dto));
  },
});
